import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import { AchFormStore } from '../stores/achFormStore';

export const useACHFormStore = () =>
  useContext<{
    achFormStore: AchFormStore;
  }>(StoreContext);
